/**
 * The plain page an app shows when its build-time environment is invalid (Frontend §1.6). The zod issues go to
 * the console, never to the page.
 */
export function SiteNotConfigured() {
  return (
    <main className="site-message">
      <div className="card card-pad">
        <h1>This site isn&apos;t configured</h1>
      </div>
    </main>
  )
}
